<template>
  <div class="body__container--actions">
        <button class="help-btn" @click="$emit('onCallReception')">
          Chamar recepção
        </button>
        <!-- <div class="group-btn">
          <button
            class="try-again-btn"
            v-if="isShown"
            @click="takePicture"
            :disabled="attempts == 0"
          >
            Tirar outra foto
          </button>
          <button
            class="next-btn"
            v-if="isShown"
            :disabled="attempts == 0"
            @click="initFacilRecognition"
          >
            Próximo
          </button>
        </div> -->
      </div>
</template>
<script>
export default {
  props: {
    isSuccess: {
      type: Boolean || null
    },
  },
  emits: [
    'onTryAgain',
    'onNext',
    'onCallReception'
  ],
  methods: {
    takePicture() {
      this.$emit('onTryAgain');
    },
    initFacilRecognition() {
      this.$emit('onNext');
    },
   
  },
};
</script>
<style scoped>
.next-btn {
  background-color: #e76752;
  border: none;
  color: white;
  font-size: 20px;
  font-weight: 600;
  padding: 10px 30px;
  width: 250px;
  border-radius: 2px;
}

.next-btn:disabled {
  color: #797675;
  background-color: #8069664f;
  cursor: not-allowed;
}

.body__container--actions {
  display: flex;
  justify-content: start;
  align-items: end;
  width: 30%;
  height: 10%;
  margin-bottom: 10px;
  position: absolute;
  bottom: 30px;
}

.help-btn {
  color: white;
  border: none;
  background: linear-gradient(270deg, #EF7F55 0%, #E15550 100%);
  font-size: 16px;
  font-weight: 500;
  border-radius: 5px;
  /* border-radius: 5px; */
  padding: 10px 20px;
  /* cursor: pointer; */
}

.help-btn:disabled {
  color: #c9c3c2;
  background-color: #8069664f;
  cursor: not-allowed;
}

.group-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;

  /* gap: 20px; */
}

.try-again-btn {
  background-color: transparent;
  border: 1px solid #e76752;
  color: #e76752;
  font-size: 20px;
  font-weight: 500;
  padding: 10px 30px;
  width: 250px;
  border-radius: 2px;
}

.try-again-btn:disabled{
  background-color: transparent;
  border: 1px solid #8069664f;
  color: #8069664f;
}

</style>